/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Feat_Adv_Ai_TitleInputs */

const en_upgrade_feat_adv_ai_title = /** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced AI Intelligence`)
};

const es_upgrade_feat_adv_ai_title = /** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencia de IA Avanzada`)
};

const fr_upgrade_feat_adv_ai_title = /** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence IA avancée`)
};

const de_upgrade_feat_adv_ai_title = /** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte KI-Intelligenz`)
};

const id_upgrade_feat_adv_ai_title = /** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecerdasan AI Lanjutan`)
};

/** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */
const ja_upgrade_feat_adv_ai_title = en_upgrade_feat_adv_ai_title;

/** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */
const zh_upgrade_feat_adv_ai_title = en_upgrade_feat_adv_ai_title;

/** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */
const ar_upgrade_feat_adv_ai_title = en_upgrade_feat_adv_ai_title;

/** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */
const it_upgrade_feat_adv_ai_title = en_upgrade_feat_adv_ai_title;

/** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */
const ru_upgrade_feat_adv_ai_title = en_upgrade_feat_adv_ai_title;

/** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */
const pt_upgrade_feat_adv_ai_title = en_upgrade_feat_adv_ai_title;

/** @type {(inputs: Upgrade_Feat_Adv_Ai_TitleInputs) => LocalizedString} */
const ko_upgrade_feat_adv_ai_title = en_upgrade_feat_adv_ai_title;

/**
* | output |
* | --- |
* | "Advanced AI Intelligence" |
*
* @param {Upgrade_Feat_Adv_Ai_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_feat_adv_ai_title = /** @type {((inputs?: Upgrade_Feat_Adv_Ai_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Feat_Adv_Ai_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_feat_adv_ai_title(inputs)
	if (locale === "es") return es_upgrade_feat_adv_ai_title(inputs)
	if (locale === "fr") return fr_upgrade_feat_adv_ai_title(inputs)
	if (locale === "de") return de_upgrade_feat_adv_ai_title(inputs)
	if (locale === "ja") return ja_upgrade_feat_adv_ai_title(inputs)
	if (locale === "zh") return zh_upgrade_feat_adv_ai_title(inputs)
	if (locale === "ar") return ar_upgrade_feat_adv_ai_title(inputs)
	if (locale === "id") return id_upgrade_feat_adv_ai_title(inputs)
	if (locale === "it") return it_upgrade_feat_adv_ai_title(inputs)
	if (locale === "ru") return ru_upgrade_feat_adv_ai_title(inputs)
	if (locale === "pt") return pt_upgrade_feat_adv_ai_title(inputs)
	return ko_upgrade_feat_adv_ai_title(inputs)
});